import { TestResult } from "../core";

export const parseBooleanResult = (result: TestResult): boolean =>
  /positive/i.test(result.result);
